import { api } from './client';
import type { ApiOptions } from './client';

export type Gender = 'male' | 'female' | 'other' | '';

export interface UserProfileDto {
  email?: string;
  firstName?: string;
  lastName?: string;
  gender?: Gender;
}

export interface UserProfileUpdateDto {
  gender?: Gender;
}

export interface UserListItem {
  keycloakId: string;
  firstName: string | null;
  lastName: string | null;
  email: string | null;
}

export interface Page<T> {
  content: T[];
  totalElements: number;
  totalPages: number;
  number: number;
  size: number;
  first: boolean;
  last: boolean;
}

export interface PageParams {
  page?: number;
  size?: number;
  sort?: string;
}

function buildPageQuery(params?: PageParams): string {
  if (!params) return '';
  const qs = new URLSearchParams();
  if (params.page != null) qs.set('page', String(params.page));
  if (params.size != null) qs.set('size', String(params.size));
  if (params.sort) qs.set('sort', params.sort);
  const s = qs.toString();
  return s ? `?${s}` : '';
}

export const userApi = {
  me: (opts?: ApiOptions) => api<UserProfileDto>('/api/users/me', opts),
  update: (patch: UserProfileUpdateDto) =>
    api<UserProfileDto>('/api/users/me', {
      method: 'PATCH',
      body: JSON.stringify(patch),
    }),
  list: (params?: PageParams) => api<Page<UserListItem>>(`/api/users${buildPageQuery(params)}`),
};
